module.exports = __webpack_public_path__ + "img/camera-icon.9f59881f.svg";